/**
 * Client-side mirror of server/services/activity-tunables.ts timecard constants.
 * Keep in sync with the server-side values.
 */

/** Auto-close the open shift after this many ms of no user interaction. */
export const TIMECARD_IDLE_WINDOW_MS = 15 * 60 * 1000; // 15 minutes
